import { HomeOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import { Breadcrumb } from 'antd'
import React from 'react'


const AdminBreadCrumb = () => {
  return (
    <div>
      <Breadcrumb style={{ marginBottom: '1.5rem', display: 'none' }}>
        <Breadcrumb.Item href="">
          <HomeOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item href="">
          <span>Application List </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          Application
        </Breadcrumb.Item>
      </Breadcrumb>
    </div>
  )
}

export default AdminBreadCrumb